<template>
    <card-renderless v-slot="{
        title,
        subtitle,
        image,
        isOnBillboard,
        sendToBillboard,
        theme,
        isNumbered,
        myIndex,
        link,
        isCurrentPage,
        isKeyFact,
        keyFactTitle,
        size
    }">
        <div class="relative flex flex-col w-full h-full bg-center bg-no-repeat bg-cover rounded shadow-md select-none test t3m-Card t3m-Card--flx t3m-Card--flx-loose t3m-Card--flexColumn card swiper-lazy"
             @mouseenter="sendToBillboard"
             :class="[
             `size-${size}`, {
                 't3m-Card--flx-dark bg-black': theme === 'dark',
                 't3m-Card--flx-light bg-white': theme === 'light',
                 't3m-Card--flx-numbered': isNumbered,
                 't3m-Card--flx-currentPage': isCurrentPage,
                 't3m-Card--flx-keyFact': isKeyFact && !isCurrentPage,
                 'lg:aspect-2 overflow-hidden': size === 'sm',
                 'lg:aspect-video overflow-hidden': size === 'md',
                 'lg:aspect-1 overflow-hidden': size === 'lg',
                 'onBillboard z-10 ring-2 ring-primary': isOnBillboard,
             }]"
             :data-background="image">
            <div class="absolute inset-0 rounded"
                 :class="{
                     'bg-black bg-opacity-60': theme === 'dark',
                     'bg-white bg-opacity-60': theme === 'light',
                 }"></div>
            <div class="swiper-lazy-preloader"></div>
            <div class="absolute w-0 h-0 -ml-4 border-x-transparent t3m-Card-arrow border-x-8 left-1/2"
                 :class="{
                     'border-b-primary border-b-8 bottom-full': isOnBillboard,
                 }"></div>
            <div class="relative flex-grow px-4 pt-4 pb-8 xl:px-6 xl:pt-6 card-body"
                 :class="{
                     'text-white': theme === 'dark',
                 }">
                <h4 v-if="isKeyFact && !isCurrentPage"
                    class="text-base font-normal uppercase t3m-Card-keyFactTitle t3m-Headline t3m-Headline--centeredLine">
                    <span class="t3m-u-flx-readability">
                        <a v-if="link.length"
                           class="text-inherit"
                           :href="link"
                           v-html="keyFactTitle"
                           :aria-label="keyFactTitle"></a>
                        <span v-if="!link.length"
                              v-html="keyFactTitle"></span>
                    </span>
                </h4>
                <h3 class="mb-2 font-bold t3m-Card-title">
                    <span v-if="isNumbered"
                          class="inline-flex items-center justify-center flex-none w-8 h-8 mr-4 text-center bg-white rounded-full -translate-y-1/10 t3m-Card-number text-t3m-body">{{
                                  myIndex + 1
                          }}</span>
                    <span class="flex-1 t3m-Card-title-inner t3m-u-flx-readability">
                        <a v-if="link.length"
                           v-html="title"
                           :href="link"
                           class="block text-inherit hover:text-primary"
                           :aria-label="title"></a>
                        <span v-if="!link.length"
                              v-html="title"></span>
                    </span>
                </h3>
                <div v-if="subtitle"
                     class="text-sm t3m-Card-text t3m-u-flx-readability"
                     :class="{
                         'line-clamp-2': size === 'sm',
                         'line-clamp-3': size === 'md',
                         'line-clamp-4': size === 'lg',
                     }"
                     v-html="subtitle"></div>
                <a v-if="link.length"
                   class="absolute p-0.5 text-white rounded-full hover:text-white bottom-3 right-3 t3m-Card-btn t3m-btn-primary-icon-plus-xs bg-primary hover:bg-primary-hover"
                   :href="link"
                   aria-label="Read article">
                    <span class="sr-only">
                        Read article
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class="w-3 h-3"
                         viewBox="0 0 448 512"
                         fill="currentColor">
                        <path
                              d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z" />
                    </svg>
                </a>
            </div>
        </div>
    </card-renderless>
</template>

<script>
import CardRenderless from "@/components/Card/CardRenderless";
export default {
    components: {
        CardRenderless,
    },
};
</script>
